<template>
 <div class="compent-dialog-body">
    <div class="content">
      <el-input size="small" @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item" :placeholder="'用户名称'"
        v-model="listQuery.userName">
      </el-input>

      <el-button class="filter-item" size="small" v-waves icon="el-icon-search" @click="handleFilter">搜索</el-button>

      <el-table class="table" ref="mainTable" :key='tableKey' :data="list" v-loading="listLoading" border fit
        highlight-current-row style="width: 100%;" @row-click="rowClick">

        <el-table-column align="center" width="55">
          <template slot-scope="scope">
            <el-radio v-model="radioVal" :label="scope.$index">&thinsp;</el-radio>
          </template>
        </el-table-column>

        <el-table-column min-width="100px" :label="'用户编码'" prop="cPersonCode">
          <template slot-scope="scope">
            <span>{{scope.row.cPersonCode}}</span>
          </template>
        </el-table-column>

        <el-table-column min-width="100px" :label="'用户名'" prop="cPersonName">
          <template slot-scope="scope">
            <span>{{scope.row.cPersonName}}</span>
          </template>
        </el-table-column>

        <el-table-column min-width="100px" :label="'部门编码'" prop="cDepCode">
          <template slot-scope="scope">
            <span>{{scope.row.cDepCode}}</span>
          </template>
        </el-table-column>

         <el-table-column min-width="100px" :label="'部门名称'" prop="cDepName">
          <template slot-scope="scope">
            <span>{{scope.row.cDepName}}</span>
          </template>
        </el-table-column>
        </el-table>

      <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />
    </div>
    <div class="el-dialog__footer">
      <el-button size="mini" @click="close">取消</el-button>
      <el-button size="mini" type="primary" @click="submit">确认</el-button>
    </div>
  </div>
</template>

<script>
import { GetErpUser } from '@/api/users';
import waves from '@/directive/waves'; // 水波纹指令
import Pagination from '@/components/Pagination';

export default {
  name: 'select-erp-user',
  components: {
    Pagination
  },
  directives: {
    waves
  },
  props: ['accinfoid', 'userName'],
  data() {
    return {
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      radioVal: '',
      listQuery: { // 查询条件
        page: 1,
        limit: 20,
        userName: undefined,
        accinfoid: this.accinfoid
      }
    };
  },
  created() {
    this.getList();
  },
  watch: {
    accinfoid(val) {
      this.listQuery.accinfoid = val;
    }
  },
  methods: {
    rowClick(row) {
      this.radioVal = this.list.indexOf(row);
    },
    getList() {
      this.listLoading = true;
      GetErpUser(this.listQuery).then(response => {
        this.list = response.data;
        this.total = response.count;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.radioVal = '';
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    close() {
      this.$emit('close');
    },
    submit() {
      if (this.radioVal !== null && this.radioVal !== undefined && this.radioVal !== '') {
        var radiolist = [];
        radiolist.push({
          cPersonCode: this.list[this.radioVal].cPersonCode,
          cPersonName: this.list[this.radioVal].cPersonName,
          cDepCode: this.list[this.radioVal].cDepCode,
          cDepName: this.list[this.radioVal].cDepName,
          list: this.list
          // name: this.list[this.radioVal].name,
          // id: this.list[this.radioVal].id,
          // custid: this.list[this.radioVal].customerId,
          // custnm: this.list[this.radioVal].customerNm,
          // list: this.list
        });
        this.$emit('closeMoule', radiolist);
      } else {
        this.$alert('请选择用户!', '', {
          confirmBuwarningttonText: '确定',
          type: 'warning',
          center: 'true'
        });
        return;
      }
    }
  }
};
</script>
